/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloError } from "@apollo/client/errors";
import { useScanCloudAccountMutation } from "~/generated/graphql";

type Props = {
  onSuccess: () => void;
  onScanInProgress: () => void;
  onError: (error: ApolloError) => void;
};

export function useScanCloudAccount({
  onSuccess,
  onScanInProgress,
  onError,
}: Props) {
  const [scanCloudAccountMutation, { loading }] = useScanCloudAccountMutation({
    onCompleted: (data) => {
      if (data?.scanCloudAccount) {
        onSuccess();
      } else {
        onScanInProgress();
      }
    },
    onError: onError,
  });

  async function scanCloudAccount(id: string) {
    await scanCloudAccountMutation({
      variables: {
        id,
      },
    });
  }

  return [scanCloudAccount, loading] as const;
}
